module.exports = __webpack_public_path__ + "static/media/bg.4bd3b170.png";